<template>
  <a-modal width="670px" v-model="isShow" :title="title" :afterClose="handleCancel" :maskClosable="false">
    <a-form-model ref="formDom" :model="form" :rules="rules" labelAlign="right" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
      <a-form-model-item label="发布平台" prop="business_id">
        <a-select
          v-model="form.business_id"
          allowClear
          show-search
          option-filter-prop="children"
          placeholder="请选择"
          style="width: 100%"
        >
          <a-select-option v-for="item in platformList" :key="item.id" :value="item.id">{{ item.org }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="唯一标识" prop="identify">
        <a-input v-model.trim="form.identify" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item label="网站名称" prop="name">
        <a-input v-model.trim="form.name" placeholder="请输入" />
      </a-form-model-item>
      <a-form-item label="跳转QQ" prop="is_jump_qq">
        <a-radio-group name="radioGroup" v-model="form.is_jump_qq" :defaultValue="form.is_jump_qq">
          <a-radio v-for="item in ARTICLE_TYPE_IS_SHOW" :key="item.key" :value="item.key">{{ item.value }}</a-radio>
        </a-radio-group>
        <span style="color:red;">选是，对应链接将跳转到QQ，不再跳转到快商通</span>
      </a-form-item>
      <a-form-model-item label="跳转链接" prop="jump_link">
        <a-textarea :placeholder="jump_linkPl" v-model.trim="form.jump_link" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="引入JS" prop="introduce_js">
        <a-textarea :placeholder="introduce_jsPl" v-model.trim="form.introduce_js" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-textarea placeholder="请输入" v-model.trim="form.remark" :maxlength="200" allow-clear />
      </a-form-model-item>
    </a-form-model>
    <template slot="footer">
      <a-button key="back" @click="handleCancel"> 取 消 </a-button>
      <a-button key="submit" type="primary" :loading="btnloading" @click="handleSubmit"> 提 交 </a-button>
    </template>
  </a-modal>
</template>
<script>
import { reactive, toRefs, getCurrentInstance, defineComponent, onMounted, watch, computed } from '@vue/composition-api'
import compuedFun from '../business/index'
import { form, rules } from '../business/linkRuleList'
import dialog from '@/composables/dialog'
import api from '@/api/'
import store from '@/store/'
const title = {
  Add: '新增快商通',
  Edit: '编辑快商通',
}

export default defineComponent({
  mixins: [dialog],
  props: {
    platformList: {
      type: [Object, Array],
      default() {
        return {}
      },
    },
    classifyList: {
      type: [Object, Array],
      default() {
        return {}
      },
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    List: {
      type: Array,
      default: () => [],
    },
    params: {
      type: Object,
      default: {},
    },
  },
  setup(props, { root }) {
    const _this = getCurrentInstance()
    const state = reactive({
      rules,
      title: title.Add,
      btnloading: false,
      form: { ...form },
      // eslint-disable-next-line no-useless-escape
      introduce_jsPl: `请输入填写JS，例如：<script type="text\/javascript" src="https:\/\/kefu5.kuaishang.cn\/bs\/ks.j?cI=*****" charset="utf-8"><\/script>`,
      jump_linkPl: `请输入填写跳转链接，例如：https://kefu5.kuaishang.cn/bs/ks.j?cI=*****"`
    })
    const labelList = computed(() => {
      return store.state.label.data.WEBSITE?.WEBSITE_MAP_CHANGE_FREQ
    })

    watch(
      () => _this.params,
      async () => {
        state.form = JSON.parse(JSON.stringify(_this.params))
        state.form.business_id = state.form?.business_id ? Number(state.form.business_id) : undefined
        state.form.is_jump_qq = parseInt(_this.params.is_jump_qq)
      }
    )

    watch(
      () => _this.isEdit,
      async () => {
        state.title = _this.isEdit ? title.Edit : title.Add
      }
    )

    const methods = {
      handleSubmit() {
        state.btnloading = true
        _this.$refs.formDom.validate(async (valid) => {
          let res = null
          const data = { ...state.form }
          if (valid) {
            if (_this.isEdit) {
              res = await api.distributionUpdate(data)
            } else {
              res = await api.distributionCreate(data)
            }
            if (_this.$validate(res)) {
              this.$message.success(_this.isEdit ? '编辑成功~' : '添加成功~')
              _this.isShow = false
              state.btnloading = false
              _this.form.article_type = '' // 手动清除
              _this.$emit('handleOver')
            } else {
              state.btnloading = false
            }
          } else {
            this.$message.warning('请检查信息是否填写完成')
            state.btnloading = false
          }
        })
      },
      handleCancel() {
        this.form.is_jump_qq = 0
        _this.$refs.formDom.resetFields()
        _this.isShow = false
      },
    }
    return {
      ...toRefs(state),
      ...compuedFun(),
      ...methods,
      labelList,
    }
  },
})
</script>
